import { render, staticRenderFns } from "./CalendarEventEditor.vue?vue&type=template&id=49ada6db&scoped=true&lang=pug&"
import script from "./CalendarEventEditor.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ada6db",
  null
  
)

export default component.exports